"use client";

import { ArrowRight } from "lucide-react";

interface StatusChangeBlockProps {
  body: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export function StatusChangeBlock({ body, metadata, createdAt }: StatusChangeBlockProps) {
  const from = metadata?.fromStatus as string | undefined;
  const to = metadata?.toStatus as string | undefined;

  return (
    <div className="flex items-center gap-2 py-2">
      <div className="flex-1 border-t border-amber-300" />
      <div className="flex items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1">
        <ArrowRight className="h-3 w-3 text-amber-600" />
        <span className="text-[10px] font-medium text-amber-700">
          {from && to ? `${from} → ${to}` : body ?? "Status changed"}
        </span>
        <span className="text-[10px] text-amber-500">
          {new Date(createdAt).toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" })}
        </span>
      </div>
      <div className="flex-1 border-t border-amber-300" />
    </div>
  );
}
